var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-container" }, [
    _c("div", { staticClass: "page-header" }, [
      _c(
        "div",
        { staticClass: "d-flex align-items-center w-100" },
        [
          _c(
            "b-button",
            {
              staticClass: "mr-3",
              attrs: { variant: "link" },
              on: {
                click: function($event) {
                  return _vm.onBack()
                }
              }
            },
            [
              _c("v-icon", {
                attrs: { name: "buttons/chevrons_left", size: 13 }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("h4", { staticClass: "mb-0" }, [_vm._v(_vm._s(_vm.title))]),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticClass: "custom-btn-primary ml-auto",
              attrs: { disabled: _vm.isDisabled || _vm.loading },
              on: {
                click: function($event) {
                  return _vm.handleSubmit()
                }
              }
            },
            [
              _vm.loading
                ? _c("b-spinner", { attrs: { small: "" } })
                : _vm._e(),
              _vm._v(" "),
              _c("v-icon", { attrs: { name: "buttons/check", size: 13 } }),
              _vm._v("\n        Сохранить\n      ")
            ],
            1
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "page-body", staticStyle: { "overflow-y": "auto" } },
      [
        _c("b-skeleton-wrapper", {
          attrs: { loading: _vm.isBusy },
          scopedSlots: _vm._u([
            {
              key: "loading",
              fn: function() {
                return [
                  _c(
                    "b-tabs",
                    { staticClass: "custom-tab", attrs: { card: "" } },
                    [
                      _c("b-tab", {
                        attrs: { disabled: "" },
                        scopedSlots: _vm._u([
                          {
                            key: "title",
                            fn: function() {
                              return [
                                _c("v-icon", {
                                  staticClass: "mr-2",
                                  attrs: { name: "navbar/user", size: 13 }
                                }),
                                _vm._v(" "),
                                _c("span", [_vm._v("Персональные данные")])
                              ]
                            },
                            proxy: true
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("b-tab", {
                        attrs: { disabled: "" },
                        scopedSlots: _vm._u([
                          {
                            key: "title",
                            fn: function() {
                              return [
                                _c("v-icon", {
                                  staticClass: "mr-2",
                                  attrs: {
                                    name: "buttons/payment_card",
                                    size: 13
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", [_vm._v("Платёжные реквизиты")])
                              ]
                            },
                            proxy: true
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("b-tab", {
                        attrs: { disabled: "" },
                        scopedSlots: _vm._u([
                          {
                            key: "title",
                            fn: function() {
                              return [
                                _c("v-icon", {
                                  staticClass: "mr-2",
                                  attrs: { name: "buttons/passport", size: 13 }
                                }),
                                _vm._v(" "),
                                _c("span", [_vm._v("Паспортные данные")])
                              ]
                            },
                            proxy: true
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _vm.isVisibleForRole()
                        ? _c("b-tab", {
                            attrs: { disabled: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "title",
                                  fn: function() {
                                    return [
                                      _c("v-icon", {
                                        staticClass: "mr-2",
                                        attrs: {
                                          name: "buttons/payment",
                                          size: 13
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("Расходы")])
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              3230516252
                            )
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isVisibleForRole()
                        ? _c("b-tab", {
                            attrs: { disabled: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "title",
                                  fn: function() {
                                    return [
                                      _c("v-icon", {
                                        staticClass: "mr-2",
                                        attrs: { name: "navbar/link", size: 13 }
                                      }),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("Связи")])
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              2564778413
                            )
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("b-tab", {
                        attrs: { disabled: "" },
                        scopedSlots: _vm._u([
                          {
                            key: "title",
                            fn: function() {
                              return [
                                _c("v-icon", {
                                  staticClass: "mr-2",
                                  attrs: { name: "navbar/tasks", size: 13 }
                                }),
                                _vm._v(" "),
                                _c("span", [_vm._v("Последние заявки")])
                              ]
                            },
                            proxy: true
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-card",
                    { staticClass: "custom-card mb-2" },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            [
                              _c("b-skeleton", {
                                staticClass: "mb-2",
                                attrs: { width: "10%", height: "16%" }
                              }),
                              _vm._v(" "),
                              _c("b-skeleton", {
                                staticClass: "mb-2",
                                attrs: {
                                  type: "input",
                                  width: "100%",
                                  height: "29%"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("b-skeleton", {
                                staticClass: "mb-2",
                                attrs: { width: "10%", height: "16%" }
                              }),
                              _vm._v(" "),
                              _c("b-skeleton", {
                                staticClass: "mb-2",
                                attrs: {
                                  type: "input",
                                  width: "100%",
                                  height: "29%"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("b-skeleton", {
                                staticClass: "mb-2",
                                attrs: { width: "10%", height: "16%" }
                              }),
                              _vm._v(" "),
                              _c("b-skeleton", {
                                staticClass: "mb-2",
                                attrs: {
                                  type: "input",
                                  width: "100%",
                                  height: "29%"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "mb-2" },
                        [
                          _c(
                            "b-col",
                            [
                              _c("b-skeleton", {
                                staticClass: "mb-2",
                                attrs: { width: "6%", height: "24%" }
                              }),
                              _vm._v(" "),
                              _c("b-skeleton", {
                                attrs: {
                                  type: "input",
                                  width: "100%",
                                  height: "45%"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("b-skeleton", {
                                staticClass: "mb-2",
                                attrs: { width: "6%", height: "24%" }
                              }),
                              _vm._v(" "),
                              _c("b-skeleton", {
                                attrs: {
                                  type: "input",
                                  width: "100%",
                                  height: "45%"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("b-skeleton", {
                                staticClass: "mb-2",
                                attrs: { width: "6%", height: "24%" }
                              }),
                              _vm._v(" "),
                              _c("b-skeleton", {
                                attrs: {
                                  type: "input",
                                  width: "100%",
                                  height: "45%"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-card",
                    { staticClass: "custom-card mb-2" },
                    [
                      _c(
                        "b-row",
                        { staticClass: "mb-2" },
                        [
                          _c(
                            "b-col",
                            [
                              _c("b-skeleton", {
                                staticClass: "mb-2",
                                attrs: { width: "6%", height: "24%" }
                              }),
                              _vm._v(" "),
                              _c("b-skeleton", {
                                attrs: {
                                  type: "input",
                                  width: "100%",
                                  height: "45%"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("b-skeleton", {
                                staticClass: "mb-2",
                                attrs: { width: "6%", height: "24%" }
                              }),
                              _vm._v(" "),
                              _c("b-skeleton", {
                                attrs: {
                                  type: "input",
                                  width: "100%",
                                  height: "45%"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("b-skeleton", {
                                staticClass: "mb-2",
                                attrs: { width: "6%", height: "24%" }
                              }),
                              _vm._v(" "),
                              _c("b-skeleton", {
                                attrs: {
                                  type: "input",
                                  width: "100%",
                                  height: "45%"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-card",
                    { staticClass: "custom-card mb-2" },
                    [
                      _c(
                        "b-row",
                        { staticClass: "mb-2 pt-1" },
                        [
                          _c(
                            "b-col",
                            [
                              _c("b-skeleton", {
                                staticClass: "mb-2",
                                attrs: { width: "17%", height: "24%" }
                              }),
                              _vm._v(" "),
                              _c("b-skeleton", {
                                attrs: {
                                  type: "input",
                                  width: "100%",
                                  height: "45%"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("b-skeleton", {
                                staticClass: "mb-2",
                                attrs: { width: "17%", height: "24%" }
                              }),
                              _vm._v(" "),
                              _c("b-skeleton", {
                                attrs: {
                                  type: "input",
                                  width: "100%",
                                  height: "45%"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("b-skeleton", {
                                staticClass: "mb-2",
                                attrs: { width: "17%", height: "24%" }
                              }),
                              _vm._v(" "),
                              _c("b-skeleton", {
                                attrs: {
                                  type: "input",
                                  width: "100%",
                                  height: "45%"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-card",
                    { staticClass: "custom-card mb-2" },
                    [
                      _c(
                        "b-row",
                        { staticClass: "mb-2 pt-1" },
                        [
                          _c(
                            "b-col",
                            [
                              _c("b-skeleton", {
                                staticClass: "mb-2",
                                attrs: { width: "17%", height: "24%" }
                              }),
                              _vm._v(" "),
                              _c("b-skeleton", {
                                attrs: {
                                  type: "input",
                                  width: "100%",
                                  height: "45%"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("b-skeleton", {
                                staticClass: "mb-2",
                                attrs: { width: "17%", height: "24%" }
                              }),
                              _vm._v(" "),
                              _c("b-skeleton", {
                                attrs: {
                                  type: "input",
                                  width: "100%",
                                  height: "45%"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("b-skeleton", {
                                staticClass: "mb-2",
                                attrs: { width: "17%", height: "24%" }
                              }),
                              _vm._v(" "),
                              _c("b-skeleton", {
                                attrs: {
                                  type: "input",
                                  width: "100%",
                                  height: "45%"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            [
                              _c("b-skeleton", {
                                staticClass: "mb-2",
                                attrs: { width: "17%", height: "24%" }
                              }),
                              _vm._v(" "),
                              _c("b-skeleton", {
                                attrs: {
                                  type: "input",
                                  width: "100%",
                                  height: "45%"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              },
              proxy: true
            },
            {
              key: "default",
              fn: function() {
                return [
                  _c(
                    "b-form",
                    {
                      on: {
                        submit: function($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.handleSubmit.apply(null, arguments)
                        }
                      }
                    },
                    [
                      _c(
                        "b-tabs",
                        { staticClass: "custom-tabs", attrs: { card: "" } },
                        [
                          _c(
                            "b-tab",
                            {
                              attrs: { active: "" },
                              scopedSlots: _vm._u([
                                {
                                  key: "title",
                                  fn: function() {
                                    return [
                                      _c("v-icon", {
                                        staticClass: "mr-2",
                                        attrs: { name: "navbar/user", size: 13 }
                                      }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v("Персональные данные")
                                      ])
                                    ]
                                  },
                                  proxy: true
                                }
                              ])
                            },
                            [
                              _vm._v(" "),
                              _c(
                                "b-card",
                                { staticClass: "custom-card mb-2" },
                                [
                                  _c(
                                    "h6",
                                    { staticClass: "text-muted text-small" },
                                    [_vm._v("ОСНОВНАЯ ИНФОРМАЦИЯ")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-name",
                                                label: "ФИО"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  size: "sm",
                                                  type: "text",
                                                  disabled: _vm.isDisabled,
                                                  state: _vm.getFieldState(
                                                    "name"
                                                  ),
                                                  placeholder: _vm.$t(
                                                    "message.workers.modal.namePlaceholder"
                                                  )
                                                },
                                                model: {
                                                  value: _vm.newItem.name,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "name",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "newItem.name"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-age",
                                                label: "Пол"
                                              }
                                            },
                                            [
                                              _c(
                                                "b-form-select",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    disabled: _vm.isDisabled
                                                  },
                                                  model: {
                                                    value: _vm.newItem.sex,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.newItem,
                                                        "sex",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "newItem.sex"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "option",
                                                    {
                                                      attrs: { disabled: "" },
                                                      domProps: { value: null }
                                                    },
                                                    [_vm._v("Выберите пол")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "option",
                                                    {
                                                      domProps: { value: true }
                                                    },
                                                    [_vm._v("Мужчина")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "option",
                                                    {
                                                      domProps: { value: false }
                                                    },
                                                    [_vm._v("Женщина")]
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-age",
                                                label: "Возраст"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  size: "sm",
                                                  type: "text",
                                                  disabled: _vm.isDisabled,
                                                  placeholder: "Введите возраст"
                                                },
                                                model: {
                                                  value: _vm.newItem.age,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "age",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "newItem.age"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-town",
                                                label: "Город"
                                              }
                                            },
                                            [
                                              _c("town-select", {
                                                attrs: {
                                                  value: _vm.newItem.town_id,
                                                  "is-disabled": _vm.isDisabled,
                                                  state: _vm.getFieldState(
                                                    "town_id"
                                                  )
                                                },
                                                on: {
                                                  onSelect: _vm.onSelectTown
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-address",
                                                label: "Адрес проживания"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  size: "sm",
                                                  type: "text",
                                                  disabled: _vm.isDisabled,
                                                  placeholder: _vm.$t(
                                                    "message.workers.modal.addressPlaceholder"
                                                  )
                                                },
                                                model: {
                                                  value: _vm.newItem.address,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "address",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "newItem.address"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            { attrs: { label: "Телефон" } },
                                            [
                                              _c(
                                                "b-input-group",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    prepend: _vm.phoneInputPrefix(
                                                      _vm.newItem.phone
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("b-form-input", {
                                                    attrs: {
                                                      size: "sm",
                                                      type: "tel",
                                                      disabled: _vm.isDisabled,
                                                      placeholder: _vm.$t(
                                                        "message.workers.modal.phonePlaceholder"
                                                      ),
                                                      state: _vm.phoneState
                                                    },
                                                    model: {
                                                      value: _vm.newItem.phone,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.newItem,
                                                          "phone",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "newItem.phone"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-form-invalid-feedback",
                                                    {
                                                      attrs: {
                                                        state: _vm.phoneState
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                          " +
                                                          _vm._s(
                                                            _vm.phoneInvalidFeedback
                                                          ) +
                                                          "\n                        "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-card",
                                { staticClass: "custom-card mb-2" },
                                [
                                  _c(
                                    "h6",
                                    { staticClass: "text-muted text-small" },
                                    [_vm._v("ДОКУМЕНТЫ И СТАТУС")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "3" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-inn",
                                                label: "ИНН"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  size: "sm",
                                                  type: "text",
                                                  disabled: _vm.isDisabled,
                                                  placeholder: "Введите ИНН"
                                                },
                                                model: {
                                                  value: _vm.newItem.inn,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "inn",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "newItem.inn"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "3" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-snils",
                                                label: "СНИЛС"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  size: "sm",
                                                  type: "text",
                                                  disabled: _vm.isDisabled,
                                                  placeholder: "Введите СНИЛС"
                                                },
                                                model: {
                                                  value: _vm.newItem.snils,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "snils",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "newItem.snils"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "3" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-passport-type",
                                                label: "Гражданство"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  size: "sm",
                                                  type: "text",
                                                  disabled: _vm.isDisabled,
                                                  placeholder: _vm.$t(
                                                    "message.workers.modal.passport_typePlaceholder"
                                                  )
                                                },
                                                model: {
                                                  value:
                                                    _vm.newItem.passport_type,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "passport_type",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newItem.passport_type"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "3" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-employment-type",
                                                label: "Тип занятости"
                                              }
                                            },
                                            [
                                              _c("base-select", {
                                                attrs: {
                                                  "is-disabled": _vm.isDisabled,
                                                  state: _vm.getFieldState(
                                                    "employment_type"
                                                  ),
                                                  options: _vm.employmentTypes,
                                                  value:
                                                    _vm.newItem.employment_type,
                                                  placeholder:
                                                    "Выберите тип занятости"
                                                },
                                                on: {
                                                  onSelect:
                                                    _vm.onSelectEmploymentType
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-card",
                                { staticClass: "custom-card mb-2" },
                                [
                                  _c(
                                    "h6",
                                    { staticClass: "text-muted text-small" },
                                    [_vm._v("ДЕТАЛИ РАБОТЫ")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-skills",
                                                label: _vm.$t(
                                                  "message.workers.modal.skillInput"
                                                )
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  size: "sm",
                                                  type: "text",
                                                  disabled: _vm.isDisabled,
                                                  placeholder: _vm.$t(
                                                    "message.workers.modal.skillPlaceholder"
                                                  )
                                                },
                                                model: {
                                                  value: _vm.newItem.skill,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "skill",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "newItem.skill"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-ready",
                                                label: _vm.$t(
                                                  "message.workers.modal.readyInput"
                                                )
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  size: "sm",
                                                  type: "text",
                                                  disabled: _vm.isDisabled,
                                                  placeholder: _vm.$t(
                                                    "message.workers.modal.readyPlaceholder"
                                                  )
                                                },
                                                model: {
                                                  value: _vm.newItem.ready,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "ready",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "newItem.ready"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            { attrs: { label: "Уровень КПД" } },
                                            [
                                              _c("base-select", {
                                                attrs: {
                                                  "is-disabled": _vm.isDisabled,
                                                  state: _vm.getFieldState(
                                                    "level_efficiency"
                                                  ),
                                                  options:
                                                    _vm.levelEfficiencyOptions,
                                                  value:
                                                    _vm.newItem
                                                      .level_efficiency,
                                                  placeholder:
                                                    "Выберите уровень КПД"
                                                },
                                                on: {
                                                  onSelect:
                                                    _vm.onSelectLevelEfficiency
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-card",
                                { staticClass: "custom-card" },
                                [
                                  _c("h6", { staticClass: "text-muted mb-0" }, [
                                    _vm._v("ПРИМЕЧАНИЕ")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-status",
                                                label: "Статус исполнителя"
                                              }
                                            },
                                            [
                                              _c("worker-status-select", {
                                                attrs: {
                                                  value: _vm.newItem.status_id,
                                                  "is-disabled": _vm.isDisabled,
                                                  "drop-up": ""
                                                },
                                                on: {
                                                  onSelect:
                                                    _vm.onSelectWorkerStatus
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-worker-source",
                                                label: "Источник"
                                              }
                                            },
                                            [
                                              _c("worker-source-select", {
                                                attrs: {
                                                  value:
                                                    _vm.newItem
                                                      .worker_source_id,
                                                  "is-disabled": _vm.isDisabled,
                                                  state: _vm.getFieldState(
                                                    "worker_source_id"
                                                  ),
                                                  "drop-up": ""
                                                },
                                                on: {
                                                  onSelect:
                                                    _vm.onSelectWorkerSource
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id:
                                                  "group-worker-source-comment",
                                                label: "Источник комментарий"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  type: "text",
                                                  size: "sm",
                                                  disabled: _vm.isDisabled
                                                },
                                                model: {
                                                  value:
                                                    _vm.newItem
                                                      .worker_source_comment,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "worker_source_comment",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newItem.worker_source_comment"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    { attrs: { label: "Комментарий" } },
                                    [
                                      _c("b-form-textarea", {
                                        attrs: {
                                          size: "sm",
                                          disabled: _vm.isDisabled,
                                          placeholder: _vm.$t(
                                            "message.workers.modal.descriptionPlaceholder"
                                          ),
                                          rows: 4,
                                          "max-rows": 6
                                        },
                                        model: {
                                          value: _vm.newItem.description,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.newItem,
                                              "description",
                                              $$v
                                            )
                                          },
                                          expression: "newItem.description"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-tab",
                            {
                              scopedSlots: _vm._u([
                                {
                                  key: "title",
                                  fn: function() {
                                    return [
                                      _c("v-icon", {
                                        staticClass: "mr-2",
                                        attrs: {
                                          name: "buttons/payment_card",
                                          size: 13
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v("Платёжные реквизиты")
                                      ])
                                    ]
                                  },
                                  proxy: true
                                }
                              ])
                            },
                            [
                              _vm._v(" "),
                              _c("b-card", { staticClass: "custom-card" }, [
                                _c(
                                  "div",
                                  { staticClass: "d-flex mb-3" },
                                  [
                                    _vm._l(_vm.paymentMethods, function(
                                      method,
                                      index
                                    ) {
                                      return [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.activePaymentId,
                                              expression: "activePaymentId"
                                            }
                                          ],
                                          staticClass: "d-none",
                                          attrs: {
                                            type: "radio",
                                            id: "method_" + method.id
                                          },
                                          domProps: {
                                            value: method.id,
                                            checked: _vm._q(
                                              _vm.activePaymentId,
                                              method.id
                                            )
                                          },
                                          on: {
                                            change: function($event) {
                                              _vm.activePaymentId = method.id
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            class: [
                                              _vm.activePaymentId === method.id
                                                ? "custom-btn-primary"
                                                : "custom-btn-secondary",
                                              "cursor-pointer mb-0"
                                            ],
                                            style: {
                                              "border-radius": _vm.getBorderRadius(
                                                index,
                                                _vm.paymentMethods.length
                                              )
                                            },
                                            attrs: {
                                              for: "method_" + method.id
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(method.name) +
                                                "\n                    "
                                            )
                                          ]
                                        )
                                      ]
                                    })
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _vm.activePaymentId === 1
                                  ? _c(
                                      "div",
                                      { key: "form-sbp" },
                                      [
                                        _c(
                                          "b-form-group",
                                          { attrs: { label: "Телефон" } },
                                          [
                                            _c(
                                              "b-input-group",
                                              {
                                                attrs: {
                                                  size: "sm",
                                                  prepend: _vm.phoneInputPrefix(
                                                    _vm.newItem.payments_sbp
                                                      .sbp_phone
                                                  )
                                                }
                                              },
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    id: "sbp-phone",
                                                    type: "tel",
                                                    size: "sm",
                                                    readonly: _vm.isDisabled,
                                                    placeholder: _vm.$t(
                                                      "message.workers.modal.phonePlaceholder"
                                                    )
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newItem.payments_sbp
                                                        .sbp_phone,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.newItem
                                                          .payments_sbp,
                                                        "sbp_phone",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newItem.payments_sbp.sbp_phone"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: { label: "ФИО получателя" }
                                          },
                                          [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "sbp-name",
                                                size: "sm",
                                                readonly: _vm.isDisabled
                                              },
                                              model: {
                                                value:
                                                  _vm.newItem.payments_sbp
                                                    .recipient_name,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.newItem.payments_sbp,
                                                    "recipient_name",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "newItem.payments_sbp.recipient_name"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm.activePaymentId === 2
                                  ? _c(
                                      "div",
                                      { key: "form-card" },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "message.workers.modal.cart_numberInput"
                                              )
                                            }
                                          },
                                          [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "card-number",
                                                size: "sm",
                                                readonly: _vm.isDisabled
                                              },
                                              model: {
                                                value:
                                                  _vm.newItem.payments_card
                                                    .card_number,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.newItem.payments_card,
                                                    "card_number",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "newItem.payments_card.card_number"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm.activePaymentId === 3
                                  ? _c(
                                      "div",
                                      { key: "form-req" },
                                      [
                                        _c(
                                          "b-form-group",
                                          { attrs: { label: "Номер счёта" } },
                                          [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "req-acc",
                                                size: "sm",
                                                readonly: _vm.isDisabled
                                              },
                                              model: {
                                                value:
                                                  _vm.newItem.payments_req
                                                    .account_number,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.newItem.payments_req,
                                                    "account_number",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "newItem.payments_req.account_number"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-form-group",
                                          { attrs: { label: "БИК" } },
                                          [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "req-bik",
                                                size: "sm",
                                                readonly: _vm.isDisabled
                                              },
                                              model: {
                                                value:
                                                  _vm.newItem.payments_req.bik,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.newItem.payments_req,
                                                    "bik",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "newItem.payments_req.bik"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: { label: "ФИО получателя" }
                                          },
                                          [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "req-name",
                                                size: "sm",
                                                readonly: _vm.isDisabled
                                              },
                                              model: {
                                                value:
                                                  _vm.newItem.payments_req
                                                    .recipient_name,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.newItem.payments_req,
                                                    "recipient_name",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "newItem.payments_req.recipient_name"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-tab",
                            {
                              scopedSlots: _vm._u([
                                {
                                  key: "title",
                                  fn: function() {
                                    return [
                                      _c("v-icon", {
                                        staticClass: "mr-2",
                                        attrs: {
                                          name: "buttons/passport",
                                          size: 13
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("Паспортные данные")])
                                    ]
                                  },
                                  proxy: true
                                }
                              ])
                            },
                            [
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { lg: "6" } },
                                    [
                                      _c(
                                        "b-card",
                                        { staticClass: "custom-card" },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-passport-series",
                                                label: "Серия"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  size: "sm",
                                                  type: "text",
                                                  disabled: _vm.isDisabled,
                                                  placeholder: "Введите серию"
                                                },
                                                model: {
                                                  value:
                                                    _vm.newItem.passport
                                                      .passport_series,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem.passport,
                                                      "passport_series",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newItem.passport.passport_series"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-passport-number",
                                                label: "Номер"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  size: "sm",
                                                  type: "text",
                                                  disabled: _vm.isDisabled,
                                                  placeholder: "Введите номер"
                                                },
                                                model: {
                                                  value:
                                                    _vm.newItem.passport
                                                      .passport_number,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem.passport,
                                                      "passport_number",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newItem.passport.passport_number"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-passport-birthdate",
                                                label: "Дата рождения"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  size: "sm",
                                                  type: "date",
                                                  disabled: _vm.isDisabled
                                                },
                                                model: {
                                                  value:
                                                    _vm.newItem.passport
                                                      .birth_date,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem.passport,
                                                      "birth_date",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newItem.passport.birth_date"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-passport-birthplace",
                                                label: "Место рождения"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  size: "sm",
                                                  type: "text",
                                                  disabled: _vm.isDisabled,
                                                  placeholder:
                                                    "Введите место рождения"
                                                },
                                                model: {
                                                  value:
                                                    _vm.newItem.passport
                                                      .birth_place,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem.passport,
                                                      "birth_place",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newItem.passport.birth_place"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-passport-issued-by",
                                                label: "Кем выдан"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  size: "sm",
                                                  type: "text",
                                                  disabled: _vm.isDisabled,
                                                  placeholder:
                                                    "Введите Кем выдан"
                                                },
                                                model: {
                                                  value:
                                                    _vm.newItem.passport
                                                      .issued_by,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem.passport,
                                                      "issued_by",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newItem.passport.issued_by"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-passport-issue-date",
                                                label: "Дата выдачи"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  size: "sm",
                                                  type: "date",
                                                  disabled: _vm.isDisabled
                                                },
                                                model: {
                                                  value:
                                                    _vm.newItem.passport
                                                      .issue_date,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem.passport,
                                                      "issue_date",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newItem.passport.issue_date"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id:
                                                  "group-passport-department-code",
                                                label: "Код подразделения"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  size: "sm",
                                                  type: "text",
                                                  disabled: _vm.isDisabled,
                                                  placeholder:
                                                    "Введите Код подразделения"
                                                },
                                                model: {
                                                  value:
                                                    _vm.newItem.passport
                                                      .department_code,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem.passport,
                                                      "department_code",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newItem.passport.department_code"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id:
                                                  "group-passport-registration-address",
                                                label: "Адрес регистрации"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  size: "sm",
                                                  type: "text",
                                                  disabled: _vm.isDisabled,
                                                  placeholder:
                                                    "Введите Адрес регистрации"
                                                },
                                                model: {
                                                  value:
                                                    _vm.newItem.passport
                                                      .registration_address,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem.passport,
                                                      "registration_address",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newItem.passport.registration_address"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { lg: "6" } },
                                    [
                                      _c(
                                        "b-card",
                                        { staticClass: "custom-card" },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-passport",
                                                label: _vm.$t(
                                                  "message.workers.modal.passport_urlInput"
                                                )
                                              }
                                            },
                                            [
                                              !_vm.isShowFile(_vm.newItem)
                                                ? _c("b-form-file", {
                                                    ref: "file_input",
                                                    attrs: {
                                                      size: "sm",
                                                      placeholder: _vm.$t(
                                                        "message.workers.modal.passport_urlPlaceholder"
                                                      ),
                                                      "browse-text": "Выбрать",
                                                      disabled: _vm.isDisabled
                                                    },
                                                    model: {
                                                      value: _vm.passportFile,
                                                      callback: function($$v) {
                                                        _vm.passportFile = $$v
                                                      },
                                                      expression: "passportFile"
                                                    }
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.isShowFile(_vm.newItem)
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        display: "flex",
                                                        "align-items": "center",
                                                        "justify-content":
                                                          "left"
                                                      },
                                                      attrs: {
                                                        id:
                                                          "input-passport-file"
                                                      }
                                                    },
                                                    [
                                                      _c("b-img", {
                                                        staticStyle: {
                                                          cursor: "pointer"
                                                        },
                                                        attrs: {
                                                          thumbnail: "",
                                                          width: "100",
                                                          height: "100",
                                                          src: _vm.previewUrl
                                                        },
                                                        on: {
                                                          click:
                                                            _vm.downloadFile
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      !_vm.isDisabled
                                                        ? _c(
                                                            "b-btn",
                                                            {
                                                              staticClass:
                                                                "mx-2 md-0",
                                                              attrs: {
                                                                variant:
                                                                  "danger",
                                                                size: "sm"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.onRemove(
                                                                    _vm.newItem
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "message.common.searchClear"
                                                                    )
                                                                  ) +
                                                                  "\n                        "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.isVisibleForRole()
                            ? _c(
                                "b-tab",
                                {
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "title",
                                        fn: function() {
                                          return [
                                            _c("v-icon", {
                                              staticClass: "mr-2",
                                              attrs: {
                                                name: "buttons/payment",
                                                size: 13
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("span", [_vm._v("Расходы")])
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    false,
                                    3230516252
                                  )
                                },
                                [
                                  _vm._v(" "),
                                  _c("worker-costs", {
                                    ref: "worker_costs",
                                    attrs: { "is-disabled": _vm.isDisabled }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isVisibleForRole()
                            ? _c(
                                "b-tab",
                                {
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "title",
                                        fn: function() {
                                          return [
                                            _c("v-icon", {
                                              staticClass: "mr-2",
                                              attrs: {
                                                name: "navbar/link",
                                                size: 13
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("span", [_vm._v("Связи")])
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    false,
                                    2564778413
                                  )
                                },
                                [
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "6" } },
                                        [
                                          _c(
                                            "b-card",
                                            { staticClass: "custom-card" },
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  attrs: {
                                                    label: "Штатный сотрудник"
                                                  }
                                                },
                                                [
                                                  _c("staff-select", {
                                                    ref: "staff_select",
                                                    on: {
                                                      onSelect:
                                                        _vm.updateStaffId
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "6" } },
                                        [
                                          _c(
                                            "b-card",
                                            { staticClass: "custom-card" },
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  attrs: {
                                                    label:
                                                      "Интеграция Баланс ПРО"
                                                  }
                                                },
                                                [
                                                  _vm.workerIntegration
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-secondary text-small"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        Идентификатор " +
                                                              _vm._s(
                                                                _vm
                                                                  .workerIntegration
                                                                  .balans_pro_id
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  !_vm.workerIntegration
                                                    ? _c(
                                                        "b-row",
                                                        {
                                                          attrs: {
                                                            "no-gutters": ""
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "b-col",
                                                            {
                                                              attrs: {
                                                                cols: "5"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "b-form-input",
                                                                {
                                                                  attrs: {
                                                                    id:
                                                                      "input-inn",
                                                                    size: "sm",
                                                                    type:
                                                                      "text",
                                                                    disabled:
                                                                      _vm.isDisabled,
                                                                    placeholder:
                                                                      "Введите ИНН для поиска"
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.innIntegration,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.innIntegration = $$v
                                                                    },
                                                                    expression:
                                                                      "innIntegration"
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "b-col",
                                                            {
                                                              attrs: {
                                                                cols: "5"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "organization-select",
                                                                {
                                                                  ref:
                                                                    "organization_select",
                                                                  staticClass:
                                                                    "ml-1",
                                                                  attrs: {
                                                                    id:
                                                                      "input-org-select",
                                                                    value: 0
                                                                  },
                                                                  on: {
                                                                    onSelect:
                                                                      _vm.onSelectOrg
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "b-col",
                                                            {
                                                              attrs: {
                                                                cols: "2"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "b-button",
                                                                {
                                                                  staticClass:
                                                                    "custom-btn-secondary ml-1",
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.findBalansProWorkerHandler()
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                            Связать\n                          "
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.workerIntegration
                                                    ? _c(
                                                        "b-button",
                                                        {
                                                          staticClass: "ml-3",
                                                          attrs: {
                                                            size: "sm",
                                                            variant: "danger"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.prepareUnlinkBalansProWorkerHandler()
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        Отвязать\n                      "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "b-tab",
                            {
                              scopedSlots: _vm._u([
                                {
                                  key: "title",
                                  fn: function() {
                                    return [
                                      _c("v-icon", {
                                        staticClass: "mr-2",
                                        attrs: {
                                          name: "navbar/tasks",
                                          size: 13
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("Последние заявки")])
                                    ]
                                  },
                                  proxy: true
                                }
                              ])
                            },
                            [
                              _vm._v(" "),
                              _vm.isBusy || _vm.lastTasks.length > 0
                                ? [
                                    _c(
                                      "div",
                                      { staticClass: "page-table-container" },
                                      [
                                        _c("b-table", {
                                          staticClass: "mb-0 custom-table",
                                          attrs: {
                                            items: _vm.lastTasks,
                                            fields: _vm.lastTasksFields
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "cell(start_date)",
                                                fn: function(row) {
                                                  return [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.formatTableDateTime(
                                                            row.item.start_date
                                                          )
                                                        ) +
                                                        "\n                    "
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            1228550739
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                : _c(
                                    "div",
                                    { staticClass: "empty-state-container" },
                                    [
                                      _c("v-icon", {
                                        attrs: {
                                          name: "navbar/empty_table",
                                          size: 90
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("h5", [_vm._v("Нет последних заявок")])
                                    ],
                                    1
                                  )
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              },
              proxy: true
            }
          ])
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-43acf068", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43acf068","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Workers/Worker.vue
// module id = null
// module chunks = 